<template>
 <v-breadcrumbs v-if="this.$route.name!='main'"
                :items="breadCrumbs"
                class="breadcrumbs"
 >
   <template v-slot:item="{ item }">
     <v-breadcrumbs-item
        :to="item.to"
        :disabled="item.disabled"
        class="pt-5"
        exact
      >
        {{ getBreadcrumbText(item) }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>
<script>
import { mdiChevronRight } from '@mdi/js'

// Соответствие ключей i18n (message.xxx) и id_content подразделов из админки
const SUBMENU_KEY_TO_ID = {
  submenu1: 71,
  submenu2: 75,
  submenu3: 77,
  submenu4: 79,
  submenu5: 73,
  aboutUsSubmenu1: 52,
  aboutUsSubmenu2: 54,
  aboutUsSubmenu3: 56,
  aboutUsSubmenu4: 58,
  aboutUsSubmenu5: 60,
  partnershipSubmenu1: 62,
  partnershipSubmenu2: 64,
  partnershipSubmenu3: 66,
  partnershipSubmenu4: 68
}

const SUBMENU_IDS = Object.values(SUBMENU_KEY_TO_ID)

export default {
  name: 'Breadcrumbs',
  data () {
    return {
      svgDivider: mdiChevronRight,
      breadcrumbList: []
    }
  },
  mounted () {
    this.$store.dispatch('contentChanges/GET_CONTENT', { id_list: SUBMENU_IDS })
  },
  computed: {
    breadCrumbs () {
      if (typeof this.$route.meta.breadCrumb !== 'function') {
        return this.$route.meta.breadCrumb
      }
      let funcsToChangeBreadCrumbText = {
        'IdGroupToGroupName': this.IdGroupToGroupName,
        'GetCurrentProductName': this.GetCurrentProductName,
        'GetCurrentGroupName': this.GetCurrentGroupName
      }
      let funcsToChangeBredCrumbProps = {
        'GetCurrentGroupId': this.GetCurrentGroupId
      }
      let returnBreadCrumbs = this.$route.meta.breadCrumb.call(this.$route).map(bredCrumb => {
        if (typeof bredCrumb.functionForText !== 'string') {
          return bredCrumb
        }
        let functionForText = bredCrumb.functionForText
        if ((typeof funcsToChangeBreadCrumbText[functionForText] === 'function') &&
            (typeof bredCrumb.text === 'string')) {
          let text = bredCrumb.text
          bredCrumb.text = funcsToChangeBreadCrumbText[functionForText](this.$route.params[text.slice(1)])
        }
        if (typeof bredCrumb.to === 'object') {
          if (typeof bredCrumb.to.params === 'object') {
            if (typeof bredCrumb.functions_for_params === 'object') {
              for (let propKey in bredCrumb.to.params) {
                for (let funcKey in bredCrumb.functions_for_params) {
                  if (propKey === funcKey) {
                    let func = bredCrumb.functions_for_params[funcKey]
                    if (bredCrumb.to.params[propKey] === null) {
                      bredCrumb.to.params[propKey] = funcsToChangeBredCrumbProps[func]()
                    } else {
                      bredCrumb.to.params[propKey] = funcsToChangeBredCrumbProps[func](propKey)
                    }
                  }
                }
              }
            }
          }
        }
        return bredCrumb
      })
      returnBreadCrumbs = returnBreadCrumbs.filter(breadCrumb => breadCrumb.text !== '' && typeof breadCrumb.text !== 'undefined')
      return returnBreadCrumbs
    },
    lang () { return this.$i18n.locale }
  },

  methods: {
    getBreadcrumbText (item) {
      const text = item.text
      if (typeof text !== 'string' || !text.startsWith('message.')) {
        return text
      }
      const key = text.replace('message.', '')
      const id = SUBMENU_KEY_TO_ID[key]
      if (id != null) {
        const content = this.$store.getters['contentChanges/contentById'](id)
        if (content) {
          return this.lang === 'ru' ? (content.value_rus || this.$t(text)) : (content.value_eng || this.$t(text))
        }
      }
      return this.$t(text)
    },
    IdGroupToGroupName (idGroup) {
      if (!Array.isArray(this.$store.state.groups.data)) { return '' }
      if (this.lang === 'ru') { if (typeof this.$store.getters['groups/group_by_id'](idGroup) !== 'undefined') { return this.$store.getters['groups/group_by_id'](idGroup)['name_rus'] } }
      if (this.lang === 'en-US') { if (typeof this.$store.getters['groups/group_by_id'](idGroup) !== 'undefined') { return this.$store.getters['groups/group_by_id'](idGroup)['name_en'] } }
      return ''
    },
    GetCurrentProductName () {
      if (this.lang === 'ru') { if (typeof this.$store.state.products.current.name_rus !== 'undefined') { return this.$store.state.products.current.name_rus } }
      if (this.lang === 'en-US') { if (typeof this.$store.state.products.current.name_en !== 'undefined') { return this.$store.state.products.current.name_en } }
      return ''
    },
    GetCurrentGroupId () {
      if (typeof this.$store.getters['groups/get_current'] !== 'undefined') {
        return this.$store.getters['groups/get_current'].id
      }
      return ' '
    },
    GetCurrentGroupName () {
      if (this.lang === 'ru') {
        if (typeof this.$store.getters['groups/get_current'] !== 'undefined') {
          return this.$store.getters['groups/get_current']['name_rus']
        }
        return 'У товара нет категории'
      }
      if (this.lang === 'en-US') {
        if (typeof this.$store.getters['groups/get_current'] !== 'undefined') {
          return this.$store.getters['groups/get_current']['name_en']
        }
        return 'Product has not category'
      }
      return 'У товара нет категории'
    }
  }
}
</script>
